import {  Component, OnInit, OnDestroy } from '@angular/core';
import {  FieldType } from 'ng-formly';
import { EntityfieldApi } from '../../sdk/services/custom';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from "lodash";

/*
This custom field is used to select entities for an app.
*/

@Component({
  selector: 'formly-entity-selector',
  template: `
   <ng-select *ngIf="items.length > 0"   
   (data)="value"  
              [active]="selectedvalues"
              (data)="refreshValue($event)"
              (selected)="selected($event)"
              (removed)="removed($event)"
              [items]="items"
              [multiple]="true"
               [disabled]="to.disabled"
              placeholder="" >
  </ng-select>
  `, styleUrls: ['./ng2select.scss'],
  providers: [EntityfieldApi]
})
export class EntityfieldMultipleSelect extends FieldType implements OnInit, OnDestroy {
  _loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
  items: any = [];
  selectedvalues: any = [];
  constructor(private _EntityfieldApi: EntityfieldApi) {
    super();

  }

  ngOnInit() {
    this.selectedvalues = [];
    //1) Load the drop down values    
    this._loopbackfilter.where = { 'entityId': this.model.entityId };
    //Hack - Get the app id from the model itself.
    //Get the entities for the App
    this._EntityfieldApi.find(this._loopbackfilter).subscribe((entities) => {
      if (entities) {

        for (var i = 0; i < entities.length; i++) {
          if (this.model[this.key] && this.model[this.key].indexOf(entities[i]["id"]) > -1)
            this.selectedvalues.push({ id: entities[i]["id"], text: entities[i]["label"] });
          else
            this.items.push({ id: entities[i]["id"], text: entities[i]["label"] })

        }
        //Sort the values
        this.items = _.sortBy(this.items, 'text');
      }
    });

  }

  ngOnDestroy() {
    this.selectedvalues = [];
  }

  private value: any = {};


  public selected(value: any): void {
    /*
    Push the selected value to the model
    */
    if (this.model[this.key] && this.model[this.key].length) {
      this.model[this.key].push(value.id);
    } else {
      this.model[this.key] = [value.id];
    }

  }

  public removed(value: any): void {

    /*
   Remove the removed value to the model
   */
    if (this.model[this.key] && this.model[this.key].length) {
      this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
    }
  }

  public typed(value: any): void {

  }

  public refreshValue(value: any): void {
    this.value = value;
  }


}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectentityfield-multiple.ts